import TimeframeLabel from './TimeframeLabel';

export default TimeframeLabel;
